import React from 'react';

export function SkeletonCard({ count = 1, type = 'stat' }) {
  const items = Array.from({ length: count });

  if (type === 'stat') {
    return (
      <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-4">
        {items.map((_, i) => (
          <div key={i} className="bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700 p-4 shadow-sm animate-pulse">
            <div className="h-4 bg-gray-200 dark:bg-slate-700 rounded w-1/2 mb-3"></div>
            <div className="h-8 bg-gray-300 dark:bg-slate-600 rounded w-3/4 mb-3"></div>
            <div className="h-3 bg-gray-200 dark:bg-slate-700 rounded w-1/3"></div>
          </div>
        ))}
      </div>
    );
  }

  if (type === 'chart') {
    return (
      <div className="bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700 p-6 shadow-sm animate-pulse">
        <div className="h-4 bg-gray-200 dark:bg-slate-700 rounded w-1/4 mb-6"></div>
        <div className="h-64 bg-gray-100 dark:bg-slate-800 rounded"></div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {items.map((_, i) => (
        <div key={i} className="bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700 p-4 shadow-sm animate-pulse">
          <div className="h-4 bg-gray-200 dark:bg-slate-700 rounded w-1/3 mb-3"></div>
          <div className="h-3 bg-gray-100 dark:bg-slate-800 rounded w-full mb-2"></div>
          <div className="h-3 bg-gray-100 dark:bg-slate-800 rounded w-5/6"></div>
        </div>
      ))}
    </div>
  );
}
